import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NetworkStatusComponent } from './network-status/network-status.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    NetworkStatusComponent
  ],
  exports: [
    NetworkStatusComponent
  ]

})
export class NetworkStatusModule {}
